// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionComparisonChangesInner
 */
export interface VersionComparisonChangesInner {
    /**
     * 
     * @type {any}
     * @memberof VersionComparisonChangesInner
     */
    after?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VersionComparisonChangesInner
     */
    before?: any | null;
    /**
     * 
     * @type {string}
     * @memberof VersionComparisonChangesInner
     */
    change_type?: VersionComparisonChangesInnerChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VersionComparisonChangesInner
     */
    section?: string;
}


/**
 * @export
 */
export const VersionComparisonChangesInnerChangeTypeEnum = {
    Added: 'ADDED',
    Deleted: 'DELETED',
    Modified: 'MODIFIED'
} as const;
export type VersionComparisonChangesInnerChangeTypeEnum = typeof VersionComparisonChangesInnerChangeTypeEnum[keyof typeof VersionComparisonChangesInnerChangeTypeEnum];


/**
 * Check if a given object implements the VersionComparisonChangesInner interface.
 */
export function instanceOfVersionComparisonChangesInner(value: object): value is VersionComparisonChangesInner {
    return true;
}

export function VersionComparisonChangesInnerFromJSON(json: any): VersionComparisonChangesInner {
    return VersionComparisonChangesInnerFromJSONTyped(json, false);
}

export function VersionComparisonChangesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionComparisonChangesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'after': json['after'] == null ? undefined : json['after'],
        'before': json['before'] == null ? undefined : json['before'],
        'change_type': json['change_type'] == null ? undefined : json['change_type'],
        'section': json['section'] == null ? undefined : json['section'],
    };
}

export function VersionComparisonChangesInnerToJSON(json: any): VersionComparisonChangesInner {
    return VersionComparisonChangesInnerToJSONTyped(json, false);
}

export function VersionComparisonChangesInnerToJSONTyped(value?: VersionComparisonChangesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'after': value['after'],
        'before': value['before'],
        'change_type': value['change_type'],
        'section': value['section'],
    };
}
